import React from 'react'
import { Link } from "gatsby"
import { ShowProcessedImage } from "../../common/ggfx-client/module/components/show-image"
import imageConfig from "../../../static/images/config.json"
import NoImage from "../../images/manager-img.png"
import moment from "moment";
import './PropertySlider.scss'

const PropertySliderNo = (props) => {
  return (
    <div className={`property-card ${props.offPlan ? 'off-plan-card' : ''}`}>
      {!props.offPlan ?
        <Link to={props.propertyDetailsLink}>
          <div className='property-img'>
            {props.propertyImages && props.propertyImages.length > 0 ?
             <img src={props.propertyImages[0].url} alt="card-img" /> : <img src={NoImage} alt="" />}
          </div>
          <div className='property-content'>
            {props.price ?
            <div className='head-wrap'>
              <h4 className='item-ares'>{"AED " + props.price}</h4>
            </div> : '' }
            <h3>{props.location}
            </h3>
            <p>{props.title}</p>
            {
              props.UnderOffer && <span className='offer-tag'>Under Offer</span>
            }
          </div>
        </Link>
        :
        <>
          <div className='property-img'>
            {props.propertyImages && props.propertyImages.length > 0 ?
              <ShowProcessedImage
                images={
                  props.propertyImages &&
                  props.propertyImages[0]
                }
                attr={{
                  className: "mb-0 img-fluid",
                  alt: props.location,
                }}
                transforms={imageConfig.property.searchResults.sizes}
              /> :  props.thumb ? <img src={props.thumb} alt="card-img" /> : <img src={NoImage} alt="" />}
          </div>

          <div className='property-content'>
            <h4>{props?.area}</h4>
            <h3>{props.location}</h3>
            {props.price ?
            <p>{`AED ${props.price} ${(props.max_price) ? `- AED ${props.max_price}` : ''}`}</p> : '' }
            <p>{props.bedroomsCount} Bedroom Apartments</p>
            {props?.completion_date &&
             <p>Completion Date: {moment(props?.completion_date).format('MMMM YYYY')}</p>
            }
           
            <Link to={props.propertyDetailsLink} className='view-details'>View Details</Link>
          </div>  
        </>
      }
    </div >
  )
}

export default PropertySliderNo